import { useContext } from 'react';
import { Page } from 'components';
import { Formik } from 'formik';
import { Container } from '@material-ui/core';
import { referenceDataDetailContext, referenceDataSchema } from './ReferenceDataDetailContext';
import { ReferenceDataForm } from './components';
import { useLocation } from 'react-router-dom';


let ReferenceDataDetail = () => {
    const { isLoading } = useContext(referenceDataDetailContext);

    let location = useLocation();
    let isNew = location.pathname.includes("/addnew");

    let service = useContext(referenceDataDetailContext);


    return (
        <Container maxWidth="md">
            <Page
                useHeader={true}
                title={isNew ? 'New reference data' : 'Edit reference data'}
                isLoading={isLoading}
            >
                <Formik
                    enableReinitialize={true}
                    initialValues={service.referenceData}
                    validationSchema={referenceDataSchema}
                    onSubmit={(values, action) => {
                        action.setSubmitting(false);
                        service.saveReferenceData(values);
                    }}
                >
                    <>
                        <ReferenceDataForm isSorting={service.isSorting} sortBy={service.sortBy} />
                    </>
                </Formik>
            </Page>
        </Container>
    )
}

export default ReferenceDataDetail;